import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng-v17/inputtext";
import { TooltipModule } from "primeng-v17/tooltip";
import { TranslateDirective } from "../../shared/transloco/translate.directive";
import { NewUiFormlyLanguageLevelByPlacementTestComponent } from "./new-ui-formly-language-level-by-placement-test.component";
import { DatepickerComponent } from "../../shared/form/datepicker/datepicker.component";

@Component({
  selector: "app-formly-language-level-by-placement-test",
  templateUrl: "./formly-language-level-by-placement-test.component.html",
  imports: [
    TranslateDirective,
    TooltipModule,
    FormsModule,
    InputTextModule,
    DatepickerComponent,
  ],
})
export class FormlyLanguageLevelByPlacementTestComponent extends NewUiFormlyLanguageLevelByPlacementTestComponent {}
